"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slugify = _interopRequireDefault(require("slugify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var setSlugs = function setSlugs(sections) {
  var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return sections.map(function (section) {
    var path = "".concat(parentPath, "/").concat((0, _slugify["default"])(section.title).toLowerCase());
    var withPath = {
      path: path
    };

    if (section.sections) {
      withPath.sections = setSlugs(section.sections, path);
    }

    return Object.assign({}, section, withPath);
  });
};

var _default = setSlugs;
exports["default"] = _default;